import { FC } from 'react'
import { useController } from 'react-hook-form'

import { cn } from 'utils'

import { BaseFormField } from '../BaseFormField'
import formFieldClasses from '../form-field.module.css'
import { TextareaFormFieldProps } from './types'
import styles from './textarea-form-field.module.css'

export const TextareaFormField: FC<TextareaFormFieldProps> = ({
  name,
  defaultValue = '',
  label,
  className,
  fullWidth = true,
  classNameInput,
  classNameLabel,
  defaultValueTransformer,
  after,
  description,
  variation,
  info,
  ...textareaProps
}) => {
  const { field, fieldState } = useController({
    name,
    defaultValue,
  })

  const hasError = !!fieldState.error

  return (
    <BaseFormField
      error={fieldState.error}
      label={label}
      fullWidth={fullWidth}
      className={className}
      classNameLabel={classNameLabel}
      description={description}
      variation={variation}
      info={info}
    >
      <textarea
        className={cn(
          formFieldClasses.field,
          fullWidth && formFieldClasses.fullWidth,
          hasError && formFieldClasses.errorField,
          classNameInput,
          styles.textareaFormField,
        )}
        {...field}
        {...textareaProps}
        value={defaultValueTransformer ? defaultValueTransformer(field.value) : field.value}
      />
    </BaseFormField>
  )
}
